import type { FC } from 'react';
import { forwardRef } from 'react';
import NumberFormat from 'react-number-format';

interface InputNumberFormatProps {
  inputRef: (any) => void;
  onChange: (any) => void;
  name: string;
}

const InputNumberFormat: FC<InputNumberFormatProps> = forwardRef(
  (props, ref) => {
    const { onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        style={{ textAlign: 'right' }}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
      />
    );
  },
);

export default InputNumberFormat;
